import React from 'react';
import PropTypes from 'prop-types';

import SocialShare from './index';

class SocialScrollWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      shareIcon,
      shareImage,
      shareDescription,
      locale,
      template,
      productName,
    } = this.props;
    return (
      <SocialShare
        shareIcon={shareIcon}
        shareImage={shareImage}
        shareDescription={shareDescription}
        locale={locale}
        template={template}
        productName={productName}
      />
    );
  }
}

SocialScrollWrapper.propTypes = {
  shareIcon: PropTypes.string,
  shareImage: PropTypes.string,
  shareDescription: PropTypes.string,
  locale: PropTypes.string,
  template: PropTypes.string,
  productName: PropTypes.string,
};

SocialScrollWrapper.defaultProps = {
  shareIcon: '',
  shareImage: '',
  shareDescription: '',
  locale: 'pt-BR',
  template: '',
  productName: '',
};
export default SocialScrollWrapper;
